import imagesLoaded from 'imagesloaded';
import * as Utils from './utils';

const btn =  document.querySelector('.js-index-content-more'),
    list = document.querySelector('.js-load-more-list');

if (btn && list && window.fetch) {
    // Setup click handler on load more btn
    btn.addEventListener('click', e => {
        e.preventDefault();

        btn.classList.add('loading');

        // Run post request to get more content
        fetch(`/layouts/_load-more?section=${btn.dataset.section}&offset=${btn.dataset.displayedentries}`, {
            headers: { 
                "X-Requested-With": "XMLHttpRequest" 
            }
        })
            .then(response => response.text())
            .then(data => {
                btn.classList.remove('loading');

                // Append items to list
                let newItemsHTML = Utils.stringToHTML(data);
                        
                // Loop over returned list items and insert to DOM
                newItemsHTML.querySelectorAll('li').forEach(item => {
                    list.appendChild(item);
                })

                imagesLoaded(list, () => {
                    // Run Picturefill
                    if (typeof window.picturefill !== "undefined") {
                        picturefill();
                    }

                    // Re-add the list to the imageFading array so that
                    // the new descendants are faded
                    Utils.animateInViewEls('.fading-el', 'in-view', 0.075);

                    // Re-count number of entries showing
                    let displayedEntriesCount = list.querySelectorAll('li').length;

                    // Update displayed entries count in data attr
                    btn.dataset.displayedentries = displayedEntriesCount;

                    // If we have as many displayed entries as there are total entries we can hide the load more bt
                    if (displayedEntriesCount >= parseInt(btn.dataset.totalentries, 10)) {
                        btn.classList.add('hidden');
                    }
                });
            }
        );
    });
}